// import { motion, useAnimation } from "framer-motion";
// import { useEffect, useState } from "react";

// const TypewriterText = () => {
//   const fullTextParts = [
//     { text: "Sales Made Simple for ", className: "text-charcoal" },
//     { text: "Subcontractors\n", className: "text-primary" },
//     { text: "and ", className: "text-charcoal" },
//     { text: "Building Suppliers", className: "text-primary" },
//   ];

//   const fullText = fullTextParts.map((p) => p.text).join("");
//   const [visibleChars, setVisibleChars] = useState(0);
//   const controls = useAnimation();

//   useEffect(() => {
//     let isCancelled = false;

//     const typeText = async () => {
//       for (let i = 0; i <= fullText.length; i++) {
//         if (isCancelled) return;
//         setVisibleChars(i);
//         await new Promise((res) => setTimeout(res, 50));
//       }

//       // Blink effect on full reveal
//       await controls.start({
//         opacity: [1, 0.5, 1],
//         transition: { duration: 1 },
//       });

//       await new Promise((res) => setTimeout(res, 2000)); // Pause before resetting

//       if (!isCancelled) {
//         setVisibleChars(0);
//         await controls.start({ opacity: 1 }); // Reset opacity before retyping
//       }
//     };

//     const loop = async () => {
//       while (!isCancelled) {
//         await typeText();
//       }
//     };

//     loop();

//     return () => {
//       isCancelled = true;
//       controls.stop();
//     };
//   }, [fullText, controls]);

//   // Render sliced text with correct classes
//   let count = 0;
//   const renderedSpans = fullTextParts.map((part, i) => {
//     const remainingChars = visibleChars - count;
//     const sliced = part.text.slice(0, Math.max(0, remainingChars));
//     count += part.text.length;

//     if (!sliced) return null;

//     return (
//       <span key={i} className={part.className}>
//         {sliced.split("\n").map((line, j, arr) => (
//           <span key={j}>
//             {line}
//             {j !== arr.length - 1 && <br />}
//           </span>
//         ))}
//       </span>
//     );
//   });

//   return (
//     // <motion.div
//     //   animate={controls}
//     //   initial={{ opacity: [1,0,1] }}
      
//     //   transition={{ duration: 0.8 }}
//     //   className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold text-center leading-tight"
//     // >
//     <motion.div
//   initial={{ opacity: 1 }}
//   animate={{ opacity: [1, 0, 1] }}
//   transition={{ duration: 0.8 }}
//   className="text-[24px] sm:text-2xl md:text-3xl lg:text-4xl font-semibold text-center leading-[31.2px] sm:leading-tight"
// >
//       {renderedSpans}
//       <motion.span
//         className=""
//         animate={{ opacity: [0, 1] }}
//         transition={{ repeat: Infinity, duration: 0.8, ease: "easeInOut" }}
//       >
//         |
//         </motion.span>
//     </motion.div>
//   );
// };

// export default TypewriterText;



import { motion, useAnimation } from "framer-motion";
import { useEffect, useState } from "react";
type TextPart = { text: string; className?: string };
const TypewriterText = ({ fullTextParts = [] }: { fullTextParts: TextPart[] }) => {
  // Combine all text parts to get the full text length
  const fullText = fullTextParts.map((p) => p.text).join("");
  const [visibleChars, setVisibleChars] = useState(0);
  const controls = useAnimation();

  useEffect(() => {
    let isCancelled = false;

    const typeText = async () => {
      for (let i = 0; i <= fullText.length; i++) {
        if (isCancelled) return;
        setVisibleChars(i);
        await new Promise((res) => setTimeout(res, 50)); // fixed typing speed
      }

      await controls.start({
        opacity: [1, 0.5, 1],
        transition: { duration: 1 },
      });

      await new Promise((res) => setTimeout(res, 2000)); // pause before restart

      if (!isCancelled) {
        setVisibleChars(0);
        await controls.start({ opacity: 1 }); // reset opacity before retyping
      }
    };

    const loop = async () => {
      while (!isCancelled) {
        await typeText();
      }
    };

    loop();

    return () => {
      isCancelled = true;
      controls.stop();
    };
  }, [fullText, controls]);

  // Render visible part of text with correct classes and line breaks
  let count = 0;
  const renderedSpans = fullTextParts.map((part, i) => {
    const remainingChars = visibleChars - count;
    const sliced = part.text.slice(0, Math.max(0, remainingChars));
    count += part.text.length;

    if (!sliced) return null;

    return (
      <span key={i} className={part.className}>
        {sliced.split("\n").map((line, j, arr) => (
          <span key={j}>
            {line}
            {j !== arr.length - 1 && <br />}
          </span>
        ))}
      </span>
    );
  });

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={controls}
      className="text-[24px] sm:text-2xl md:text-3xl lg:text-4xl font-semibold text-center leading-[31.2px] sm:leading-tight"
    >
      {renderedSpans}
      <motion.span
        animate={{ opacity: [0, 1] }}
        transition={{ repeat: Infinity, duration: 0.8, ease: "easeInOut" }}
      >
        |
      </motion.span>
    </motion.div>
  );
};

export default TypewriterText;
